/**
 * *
 * EPOA_PC_01
 * @param {any} BO
 */
import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as $ from 'jquery';
import * as MenuAction from './MenuAction';
/**
 * *
 * EPOA_PC_02
 * @param {any} BO
 */
const PageLoadAction = (BO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.POWorkbench,
            SDIConstants.methodNames.POWorkbench_PageLoad,
            JSON.stringify(BO),

            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.POWorkbench_PageLoad, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}


const poWorkbenchApplyFilterAction = (applyFilterBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.POWorkbench,
            SDIConstants.methodNames.POWorkbench_GridLoad,
            JSON.stringify(applyFilterBO).replaceAll(/'/g, "''"),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.POWorkbench_GridLoad, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired()
                        }
                    }
                }
            });


    } catch (ex) {
        console.log(ex);
    }
};

/**         
* PS_ZE_419_APP/Suvetha/04/14/2025
* This method invokes to handle the Export to excel
* */
const poWorkbenchExcelAction = (exportToExcelBO) => {
    try {

        SDISVC.downloadFile(
            SDIConstants.moduleNames.POWorkbench,
            SDIConstants.methodNames.POWorkbench_ExportToExcel,
            JSON.stringify(exportToExcelBO).replaceAll(/'/g, "''"),
            "POWorkbench.xlsx",
            (data) => {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                if (data.success == false && data.response) {
                    if (data.response == SDIConstants.tokenExpired) {
                        MenuAction.tokenExpired()
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

/**         
* PS_ZE_419_APP/Suvetha/04/14/2025
* This method invokes to handle the Save Button click
* */
const poWorkbenchSaveClickAction = (saveBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.POWorkbench,
            SDIConstants.methodNames.POWorkbench_SaveClick,
            JSON.stringify(saveBO).replaceAll(/'/g, "''"),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.POWorkbench_SaveClick, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired()
                        }
                    }
                }
            });


    } catch (ex) {
        console.log(ex);
    }
};

/**         
* PS_ZE_419_APP/Suvetha/04/14/2025
* This method invokes to handle the History Click
* */
const poWorkbenchGetHistoryAction = (saveBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.POWorkbench,
            SDIConstants.methodNames.POWorkbench_History,
            JSON.stringify(saveBO).replaceAll(/'/g, "''"),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.POWorkbench_History, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired()
                        }
                    }
                }
            });


    } catch (ex) {
        console.log(ex);
    }
};

const insertFavPage = async (insertFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_InsertFavPage,
            JSON.stringify(insertFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ORDERSTS_InsertFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const deleteFavPage = async (deleteFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_DeleteFavPage,
            JSON.stringify(deleteFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ORDERSTS_DeleteFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const getCurrentFavPage = async (getFavPageBO) => {
    try {
        SDISVC.callRecurringGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_GetCurrentFavPage,
            JSON.stringify(getFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ORDERSTS_CurrentFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

export { PageLoadAction, poWorkbenchApplyFilterAction, poWorkbenchExcelAction, poWorkbenchSaveClickAction, poWorkbenchGetHistoryAction, deleteFavPage, insertFavPage, getCurrentFavPage }